import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
  },
  paper: {
    boxShadow: "none",
  },
  filters: {
    padding: theme.spacing(3, 2, 2),
    background: "#F9FAFA",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  filtersLeft: {
    display: "flex",
    gap: theme.spacing(2),
  },
  filterDisplay: {
    margin: theme.spacing(4, 3, 3),
  },
  filterDisplayText: {
    fontSize: 18,
    fontWeight: 500,
  },

  body: {
    padding: theme.spacing(2),
    maxHeight: "77vh",
    overflow: "scroll",
  },
  gridContainer: {
    boxSizing: "border-box",
  },
  gridItem: {},

  //Blocks
  mainBlock: {
    display: "flex",
    gap: theme.spacing(2),
  },
  blockRoot: {
    boxSizing: "border-box",
    height: "100%",
    background: "#F9FAFA",
    padding: theme.spacing(3),
  },
  mainLeftSection: {
    background: "#F9FAFA",
    boxSizing: "border-box",
    width: "50%",
    padding: theme.spacing(3),
  },
  mainRightSection: {
    background: "#F9FAFA",
    boxSizing: "border-box",
    width: "50%",
    padding: theme.spacing(3),
  },
  mainRightSectionHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  totalsList: {
    display: "flex",
    flexDirection: "column",
  },
  totalsRow: {
    display: "flex",
    padding: theme.spacing(1, 0),
    alignItems: "center",
    justifyContent: "space-between",
  },
  totalsRowLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  totalsRowVisual: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    background: "#0129FA",
    borderRadius: 2.5,
  },
  totalsRowName: {
    fontSize: 18,
  },
  totalsRowCount: {
    fontSize: 28,
  },
  totalsSection: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    paddingBottom: theme.spacing(2),
  },
  statsBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  bottomModal: {},
  bottomBorder: {
    borderBottom: "#bebfc0 1px solid",
  },
  statsTitle: {
    fontSize: 18,
    fontWeight: 500,
  },
  statsCount: {
    fontSize: 28,
    fontWeight: 500,
  },
  smallName: {
    color: "#0E1011",
  },
  statsSection: {
    padding: theme.spacing(3, 0, 1),
  },
  statsSeactionHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  secondTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  statsList: {},
  statsRow: {
    padding: "12px 0",
    display: "flex",
    justifyContent: "space-between",
  },
  statsRowLeft: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  rowCount: {},
  modalSection: {
    display: "flex",
  },

  // List
  tableContainer: {
    maxHeight: 400,
    boxShadow: "none",
    borderRadius: theme.spacing(1),
    border: "solid 1px #BEBFC0",
  },
  tableHeadCell: {
    "&.MuiTableCell-stickyHeader": {
      background: "white",
    },
    "&.MuiTableCell-root": {
      border: "none",
      borderBottom: "solid 1px #BEBFC0",
      padding: theme.spacing(2, 0, 2, 2),
    },
  },
  tableCell: {
    "&.MuiTableCell-root": {
      border: "none",
      padding: theme.spacing(2, 2, 2, 2),
    },
  },
  firstCell: {
    "&.MuiTableCell-root": {
      padding: "16px 14px 16px 28px",
    },
  },
  cellText: {
    whiteSpace: "nowrap",
  },
  tableRowTopBorder: {
    "&.MuiTableCell-root": {
      borderTop: "solid 1px #BEBFC0",
    },
  },
  tableCellBorderLeft: {
    paddingLeft: 14,
    borderLeft: "solid 1px #BEBFC0",
  },

  driverFilterBox: {
    display: "flex",
    gap: theme.spacing(2)
  },
  driverLavel: {
    color: "#5F6164",
    margin: theme.spacing(0, 0, 0.5),
    fontSize: 14,
  },
  filterSelect: {
    minWidth: 150,
    width: 200,
    "& .MuiSelect-root": {
      padding: "8.5px 16px 12px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#828487",
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#0129FA",
    },
    "& .MuiListItemText-root": {
      margin: 0,
      display: "flex",
      alignItems: "center",
    },
    "& .MuiListItemText-primary": {
      height: 19,
    },
  },
  filterOption: {
    padding: theme.spacing(1, 2),
    "&.MuiMenuItem-root.Mui-selected ": {
      backgroundColor: "#0129FA33",
    },
    "&.MuiMenuItem-root.Mui-selected:hover ": {
      backgroundColor: "#0129FA33",
    },
    "&.MuiMenuItem-root:hover": {
      backgroundColor: "#0129FA33",
    },
  },
  "@media (max-width: 840px)": {
    filters: {
      flexDirection: "column",
      gap: 16,
    },
    filtersLeft: {
      width: "100%",
      justifyContent: "center",
    },
    filterDisplay: {
      padding: theme.spacing(0, 0, 1),
    },

    gridItem: {
      flexGrow: 0,
      flexShrink: 0,
      minWidth: "100%",
      maxWidth: "100%",
      flexBasis: "100%",
    },

    mainBlock: {
      flexDirection: "column",
    },
    mainLeftSection: {
      width: "100%",
      borderRight: "none",
      borderBottom: "#bebfc0 1px solid",
    },
    mainRightSection: {
      width: "100%",
    },
  },
}));
